"use client";

import { useEffect, useState } from "react";

const DEFAULT_WINDOW_WIDTH = 1200;
const DEFAULT_WINDOW_HEIGHT = 1200;

/**
 * Returns the current window size
 *
 * @returns { width: number, height: number }
 */
export function useWindowSize() {
    const isSSR = typeof window === "undefined";
    const [windowSize, setWindowSize] = useState({
        width: isSSR ? DEFAULT_WINDOW_WIDTH : window.innerWidth,
        height: isSSR ? DEFAULT_WINDOW_HEIGHT : window.innerHeight,
    });

    function changeWindowSize() {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }

    useEffect(() => {
        if (isSSR) {
            return;
        }

        changeWindowSize();

        window.addEventListener("resize", changeWindowSize);

        return () => {
            window.removeEventListener("resize", changeWindowSize);
        };
    }, []);

    return windowSize;
}
